import { getQueryString } from 'utility/helpers';
import { HistoryOptions } from 'utility/enumerations';
import { globalEndpoints } from './global';

export const adminEndpoints = {

  getAllPatientsList: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Patient/AllPatients?${queryString}`;
  },
  getPatientCertificationDocumentation: (queryString, options) => {
    const ops = getQueryString(options);

    return `${globalEndpoints.apiUrl}/CertificationDocumentation/admin/patient${queryString}&${ops}`;
  },
  getCertificationDocumentation: (queryString, options) => {
    const ops = getQueryString(options);
    return `${globalEndpoints.apiUrl}/CertificationDocumentation/admin/type${queryString}&${ops}`;
  },
  getDeceasedCardholder: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Tools/DeceasedCardholder?${queryString}`;
  },
  overrideOrExtendDeceasedCardholder: () => `${globalEndpoints.apiUrl}/Tools/OverrideOrExtendDeceasedCardholder`,
  getRestrictedPhysicians: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Physician/RestrictedPhysicians?${queryString}`;
  },
  getRestrictedPhysicianById: (physicianUserIdEncrypted) => {
    return `${globalEndpoints.apiUrl}/Physician/${physicianUserIdEncrypted}/restricted`;
  },
  overrideRestrictedPhysician: () => `${globalEndpoints.apiUrl}/Physician/override`,

  getDuplicateCardholder: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Tools/DuplicateCardholder?${queryString}`;
  },
  deleteDuplicateCardholder: () => `${globalEndpoints.apiUrl}/Tools/DeleteCardholder`,
  getMqaToggleHistory: (options) => `${globalEndpoints.apiUrl}/SystemManagement/GetMqaToggleHistory?${getQueryString(options)}`,
  createMqaToggle: () => `${globalEndpoints.apiUrl}/SystemManagement/mqa-toggle/switch`,
  getUserRoles: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Role/roles?${queryString}`;
  },
  deleteUserRole: () => `${globalEndpoints.apiUrl}/Role/remove`,
  getCategoriesByUserType: (userType) => {
    return `${globalEndpoints.apiUrl}/Role/${userType}/permissions`;
  },
  getUserRoleById: (roleIdEncrypted) => {
    return `${globalEndpoints.apiUrl}/Role/${roleIdEncrypted}`;
  },
  saveUserRole: () => {
    return `${globalEndpoints.apiUrl}/Role/save`;
  },
  addUserRole: () => {
    return `${globalEndpoints.apiUrl}/Role/add`;
  },
  getHistoryUrl: (options) => {
    const baseUrl = `${globalEndpoints.apiUrl}/SystemManagement/history/`;
    switch (options.SearchMode) {
      case HistoryOptions.PatientHistory:
        return `${baseUrl}patient?${getQueryString(options)}`;
      case HistoryOptions.UserHistory:
        return `${baseUrl}user?${getQueryString(options)}`;
      case HistoryOptions.OrderHistory:
        return `${baseUrl}order?${getQueryString(options)}`;
      case HistoryOptions.OrderRouteHistory:
        return `${baseUrl}orderroute?${getQueryString(options)}`;
      case HistoryOptions.SearchHistory:
        return `${baseUrl}search?${getQueryString(options)}`;
      case HistoryOptions.NegativeSearchHistory:
        return `${baseUrl}negativesearch?${getQueryString(options)}`;
      case HistoryOptions.PhysicianSearchHistory:
        return `${baseUrl}physiciansearch?${getQueryString(options)}`;
      case HistoryOptions.MailingAddressHistory:
        return `${baseUrl}mailingaddress?${getQueryString(options)}`;
      default:
        return null;
    }
  },
  get893ViolationsList: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Cardholder/Get893ViolationsDashboard?${queryString}`;
  },
  get893ViolationForm: (drugOffenseSuspensionIdEncrypted) => {
    return `${globalEndpoints.apiUrl}/Cardholder/Violation893Form/${drugOffenseSuspensionIdEncrypted}`;
  },
  download893ViolationFile: (suspensionUploadId) => `${globalEndpoints.apiUrl}/Cardholder/Violation893Form/DownloadFile?SuspensionUploadId=${suspensionUploadId}`,
  Adjudicate893Violation: () => `${globalEndpoints.apiUrl}/Cardholder/Adjudicate893Violation`,
  getActionHistoryOrderDates: () => `${globalEndpoints.apiUrl}/SystemManagement/GetActionHistoryOrderDates`,
  GetDocumentAssignmentSummary: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/GetDocumentAssignmentSummary`,
  GetDocumentAssignmentDetails: (queryString) => `${globalEndpoints.apiUrl}/CertificationDocumentation/GetDocumentAssignmentDetails?${queryString}`,
  staffDocumentAssignments: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/StaffDocumentAssignments`,
  certDocumentsForAssignment: (options) => `${globalEndpoints.apiUrl}/CertificationDocumentation/CertificationDocumentationForAssignment?${getQueryString(options)}`,
  qualDocumentsForAssignment: (options) => `${globalEndpoints.apiUrl}/CertificationDocumentation/QualificationDocumentationForAssignment?${getQueryString(options)}`,
  usersForAssignment: (options) => `${globalEndpoints.apiUrl}/CertificationDocumentation/UsersForAssignment?${getQueryString(options)}`,
  assignCertDocuments: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/AssignCertDocuments`,
  assignQualifyingDocuments: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/AssignQualifyingDocuments`,
  updateAssignableUsers: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/UpdateAssignableUsers`
};
